import { EditableComment } from '@/client';
import { EditableComponent } from '@/server/components/EditableComponent/EditableComponent';
import { RefService } from '@/server/services';
import classnames from 'classnames';

import {
  Constants,
  ContentRendererService,
  MgnlContent,
} from '@magnolia/frontend-helpers-base';
import { createElement } from 'react';

export const EditableArea = ({
  content,
  className,
  elementType,
  customView,
  children,
}: {
  content?: MgnlContent;
  className?: string | string[] | Record<string, boolean>;
  elementType?: string;
  customView?: React.ElementType;
  children?: React.ReactElement | React.ReactElement[] | null;
}) => {
  const templateAnnotations = RefService.getTemplateAnnotationsRef();
  const element: React.ReactElement = createElement(
    elementType || 'div',
    className ? { className: classnames(className) } : {}
  );
  const componentContents: MgnlContent[] =
    content?.['@nodes']?.map(
      (nodeName: string) => content[nodeName] as MgnlContent
    ) || [];
  let childContent;
  if (customView) {
    const CustomView = customView;
    childContent = <CustomView content={content} />;
  } else if (children) {
    childContent = children;
  } else {
    childContent = componentContents?.map((item, index) => (
      <EditableComponent
        key={ContentRendererService.buildKey(item)}
        content={item}
        index={index}
      />
    ));
  }

  const getAnnotation = () => {
    if (templateAnnotations && templateAnnotations[content!['@path']]) {
      return templateAnnotations[content!['@path']];
    }

    return '';
  };

  return (
    content && (
      <>
        <EditableComment annotation={getAnnotation()} shouldRefresh={true} />
        <element.type
          key={ContentRendererService.buildKey(content)}
          {...element.props}
        >
          {childContent}
        </element.type>
        <EditableComment annotation={Constants.END_AREA_COMMENT} />
      </>
    )
  );
};
